import './index.css'

const NotFound = () => (
  <div className="notFound-container">
    <img src="https://i.ibb.co/sHKx2db/Group-7520.png" alt="not found" />
    <h1>Page Not Found</h1>
    <p>We are sorry, the page you requested could not be found</p>
  </div>
)

export default NotFound
